import React from "react";
// import { Link } from "react-router-dom";
import Goback from "../../../utility/goback";
export default function header({ title, preventPage, currentPage }) {
  return (
    <>
      <div className="container-fluid" style={{ marginTop: "75px" }}>
        <div className="d-flex justify-content-between">
          <Goback></Goback>
          <div>
            <span className="font-thai-b fs-18 c-gray">
              {preventPage} &gt; <span className="c-blue">{currentPage}</span>
            </span>
          </div>
        </div>
        <div className="row d-flex">
          <div className="c-blue ml-3" style={{ textTransform: "uppercase" }}>
            <i className="fas fa-plus"></i>
            <span className="fs-18 ml-2">
              <b>{title}</b>
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
